/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminDashboardCommunicationOverviewDto } from '../models/AdminDashboardCommunicationOverviewDto';
import type { AdminDashboardContentOverviewDto } from '../models/AdminDashboardContentOverviewDto';
import type { AdminDashboardEngagementOverviewDto } from '../models/AdminDashboardEngagementOverviewDto';
import type { AdminDashboardUsersOverviewDto } from '../models/AdminDashboardUsersOverviewDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminDashboardService {
  /**
   * Get user growth and authentication stats for the admin dashboard.
   * @param days
   * @returns AdminDashboardUsersOverviewDto
   * @throws ApiError
   */
  public static adminDashboardControllerGetUsersOverview(
    days: number = 30,
  ): CancelablePromise<AdminDashboardUsersOverviewDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/dashboard/users-overview',
      query: {
        days: days,
      },
    });
  }
  /**
   * Get trail engagement stats for the admin dashboard.
   * @param days
   * @returns AdminDashboardEngagementOverviewDto
   * @throws ApiError
   */
  public static adminDashboardControllerGetEngagementOverview(
    days: number = 30,
  ): CancelablePromise<AdminDashboardEngagementOverviewDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/dashboard/engagement-overview',
      query: {
        days: days,
      },
    });
  }
  /**
   * Get newsletter, push notification and support stats for the admin dashboard.
   * @param days
   * @returns AdminDashboardCommunicationOverviewDto
   * @throws ApiError
   */
  public static adminDashboardControllerGetCommunicationOverview(
    days: number = 30,
  ): CancelablePromise<AdminDashboardCommunicationOverviewDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/dashboard/communication-overview',
      query: {
        days: days,
      },
    });
  }
  /**
   * Get SEO and blog content stats for the admin dashboard.
   * @param days
   * @returns AdminDashboardContentOverviewDto
   * @throws ApiError
   */
  public static adminDashboardControllerGetContentOverview(
    days: number = 30,
  ): CancelablePromise<AdminDashboardContentOverviewDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/dashboard/content-overview',
      query: {
        days: days,
      },
    });
  }
}
